import Chart from "react-apexcharts";
import "./BarChart.scss";

const BarChart = ({
  barChartData,
  horizontal,
  title,
  xLabel,
  yLabel,
  seriesName,
  topN,
}) => {
  // get TOP words
  if (barChartData.length > topN) {
    barChartData = barChartData.slice(barChartData.length - topN);
  }

  // prepare inputs
  let values = [];
  let categories = [];
  if (title.includes("Day of Week")) {
    const weekDays = [1, 2, 3, 4, 5, 6, 0];
    for (let i = 0; i < weekDays.length; i++) {
      categories.push(barChartData[weekDays[i]][0]);
      values.push(barChartData[weekDays[i]][1]);
    }
  } else if (title.includes("Time of Day")) {
    // categories
    categories = ["12am"];
    for (let i = 1; i < 12; i++) {
      categories.push(`${i}am`);
    }
    categories.push("12pm");
    for (let i = 1; i < 12; i++) {
      categories.push(`${i}pm`);
    }
    // values
    values = barChartData;
  } else {
    for (let i = 0; i < barChartData.length; i++) {
      categories.unshift(barChartData[i][0]);
      values.unshift(barChartData[i][1]);
    }
  }

  const isMobile = window.innerWidth < 768;

  const input = {
    options: {
      colors: ["#1491ff"],

      plotOptions: {
        bar: {
          horizontal: horizontal,
        },
      },
      title: {
        text: title,
        style: { fontSize: isMobile ? "16px" : "18px", fontFamily: "revert" },
      },
      xaxis: {
        categories: categories,
        ...(isMobile
          ? {}
          : {
              title: {
                text: xLabel,
                style: { fontSize: "14px", fontFamily: "revert" },
                margin: -50,
                floating: true,
                offsetY: horizontal ? -10 : 0,
              },
            }),

        // hide x labels
        labels: {
          show: horizontal ? false : true,
          ...(isMobile && !horizontal && title.includes("Time of Day")
            ? {
                rotate: -60,
                rotateAlways: true,
                formatter: (value) => {
                  const index = categories.indexOf(value);
                  return index !== -1 && index % 2 === 0 ? value : "";
                },
              }
            : {}),
        },
      },
      yaxis: {
        ...(isMobile
          ? {}
          : {
              title: {
                text: yLabel,
                style: {
                  fontSize: "14px",
                  fontFamily: "revert",
                },
              },
            }),
        labels: {
          show: horizontal ? true : false,
          style: { fontSize: "14px", fontFamily: "revert" },
          maxWidth: 260,
        },
      },
      // hide grid
      grid: {
        show: false,
      },
      // data labels
      dataLabels: {
        textAnchor: "middle",
        formatter: (val) => {
          if (title.includes("of") || title.includes("Talking")) {
            return `${val}%`;
          }
          return val;
        },
      },
    },
    series: [
      {
        name: seriesName,
        data: values,
      },
    ],
  };

  return (
    <article
      className={`dashboard__barchart ${
        title.includes("Talking") ? "kwdashboard__barchart" : ""
      }`}
    >
      <Chart
        options={input.options}
        series={input.series}
        type="bar"
        id={`barchart`}
        width={"100%"}
        height="315"
      />
    </article>
  );
};

export default BarChart;
